module.exports = __webpack_public_path__ + "img/4505.54b97d80.png";